import {
  $lang,
  $tenantConfiguration,
  $userLastLogin,
  $userTimezone,
  isShouldShowLastLogin,
  sendNotification,
  setShouldShowLastLogin,
  useTranslation,
} from '@msdk/common'
import { stringFormat } from '@msdk/forms'
import { useEffect } from 'react'
import { useRecoilValue } from 'recoil'

export const useNotifyLastLogin = () => {
  const t = useTranslation()

  const lastLoginEnabled = useRecoilValue($tenantConfiguration)?.lastLoginEnabled ?? false

  const userLastLogin = useRecoilValue($userLastLogin)
  const userTimezone = useRecoilValue($userTimezone)
  const lang = useRecoilValue($lang)

  useEffect(() => {
    if (isShouldShowLastLogin() && lastLoginEnabled && window.location.pathname.split('/').length > 2) {
      setShouldShowLastLogin(false)

      const formattedLastLogin = userLastLogin
        ? new Date(userLastLogin).toLocaleString(lang, {
            timeZone: userTimezone,
            day: '2-digit',
            year: 'numeric',
            month: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
          })
        : null

      const message = t('MSG_LAST_LOGIN', '**Last login:** {0}')
      const formattedMessage = stringFormat(message, formattedLastLogin || '')

      if (formattedLastLogin) {
        sendNotification({ message: formattedMessage, status: 'info', waitUserAck: false })
      }
    }
  }, [])
}
